function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Asset 3");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_5",
  "data-name": "Layer 5"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M157.5,239.269V132.5A47.554,47.554,0,0,0,110,85h0A47.554,47.554,0,0,0,62.5,132.5,107.653,107.653,0,0,0,157.5,239.269ZM110,116.213A16.288,16.288,0,1,1,93.712,132.5,16.306,16.306,0,0,1,110,116.213Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M110,60a72.48,72.48,0,0,1,60,31.851A72.48,72.48,0,0,1,230,60h19.3A107.338,107.338,0,0,0,90.7,60H110Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M277.5,132.5A47.554,47.554,0,0,0,230.005,85h0a47.555,47.555,0,0,0-47.5,47.5V239.269A107.652,107.652,0,0,0,277.5,132.5ZM230,148.788A16.288,16.288,0,1,1,246.287,132.5,16.307,16.307,0,0,1,230,148.788Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M170,265A107.661,107.661,0,0,0,63.268,359.618c82.518-4.771,153.376-53.733,189.226-123.511A131.851,131.851,0,0,1,170,265Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M113.86,252.5A133.357,133.357,0,0,1,62.5,209.867v85.267A133.351,133.351,0,0,1,113.86,252.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M230,116.213A16.288,16.288,0,1,0,246.287,132.5,16.307,16.307,0,0,0,230,116.213Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M110,148.788A16.288,16.288,0,1,0,93.712,132.5,16.306,16.306,0,0,0,110,148.788Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M340,292.282H245.546A250.589,250.589,0,0,0,302.5,132.5,131.827,131.827,0,0,0,293.689,85H315a25,25,0,0,0,25-25H280.849a132.4,132.4,0,0,0-221.7,0H0A25,25,0,0,0,25,85H46.311A131.827,131.827,0,0,0,37.5,132.5V292.282H0v25H37.5V385H50a250.7,250.7,0,0,0,172.059-67.718H340ZM182.5,132.5A47.555,47.555,0,0,1,230,85h0a47.554,47.554,0,0,1,47.5,47.5,107.652,107.652,0,0,1-95,106.769ZM170,25a107.242,107.242,0,0,1,79.3,35H230a72.48,72.48,0,0,0-60,31.851A72.48,72.48,0,0,0,110,60H90.7A107.242,107.242,0,0,1,170,25ZM110,85h0a47.554,47.554,0,0,1,47.5,47.5V239.269A107.653,107.653,0,0,1,62.5,132.5,47.554,47.554,0,0,1,110,85ZM62.5,209.867A133.357,133.357,0,0,0,113.86,252.5,133.351,133.351,0,0,0,62.5,295.134Zm.768,149.751A107.661,107.661,0,0,1,170,265a131.851,131.851,0,0,0,82.494-28.893C216.644,305.885,145.786,354.847,63.268,359.618Z"
})));

var SvgHubu = function SvgHubu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 340 385",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHubu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Hubu.a0477ad9.svg";
export { ForwardRef as ReactComponent };